<template>
  <div class="contentful">
    <b-form-group>
      <b-button
        v-for="val in value"
        :key="val.id"
        class="mb-2"
        @click="removeSelection(val)"
      >
        {{ val.prefLabel.en || val.hiddenLabel.en }}
      </b-button>
    </b-form-group>

    <b-form>
      <b-form-group>
        <b-form-input
          v-model="searchText"
          type="search"
          autocomplete="off"
          placeholder="Search for topics, centuries, organisations, people and places"
          @input="inputSearchText"
        />
      </b-form-group>
      <b-form-group>
        <b-button
          v-for="suggestion in suggestions"
          :key="suggestion.id"
          class="mb-2"
          :disabled="isSelected(suggestion)"
          @click="selectSuggestion(suggestion)"
        >
          {{ suggestion.prefLabel.en || suggestion.hiddenLabel.en }}
        </b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
  export default {
    name: 'ContentfulEntitySuggestPage',

    layout: 'contentful',

    data() {
      return {
        value: [],
        searchText: null,
        suggestions: [],
        contentfulExtensionSdk: null
      };
    },

    head() {
      return {
        title: this.$pageHeadTitle('Entity suggest - Contentful app')
      };
    },

    watch: {
      value: 'updateContentfulField'
    },

    mounted() {
      window.contentfulExtension.init(sdk => {
        this.contentfulExtensionSdk = sdk;
        if (sdk.location.is(window.contentfulExtension.locations.LOCATION_ENTRY_FIELD)) {
          sdk.window.startAutoResizer();

          const ids = sdk.field.getValue() || [];
          if (ids.length > 0) {
            this.$apis.entity.find(ids)
              .then(entities => {
                this.value = entities;
              });
          }
        }
      });
    },

    methods: {
      isSelected(suggestion) {
        return this.value.map(val => val.id).includes(suggestion.id);
      },

      async inputSearchText(val) {
        this.suggestions = await this.$apis.entity.suggest(val, { type: 'agent,concept,timespan,organization,place' });
      },

      removeSelection(remove) {
        this.value = this.value.filter(val => val.id !== remove.id);
      },

      selectSuggestion(select) {
        this.value = this.value.concat(select);
      },

      updateContentfulField() {
        this.contentfulExtensionSdk?.field?.setValue(this.value.map(val => val.id));
      }
    }
  };
</script>

<style lang="scss" scoped>
  .contentful {
    button {
      margin-right: 1rem;
    }
  }
</style>
